import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import axios from "axios";
import { ReducerEntityPrefixTypes, ReducerNamespaceTypes } from "enums";
import { getPrefix } from "features/Application/slices/models";

interface LastUpdatedResponse {
  LastUpdated: string; // Changed casing
}

// Define a service using a base URL and expected endpoints
export const sendSessionsApi = createApi({
  reducerPath: getPrefix({
    namespace: ReducerNamespaceTypes.Library,
    entity: ReducerEntityPrefixTypes.Emails,
    name: "sendSessionsApi",
  }),
  // Base query is required, but we use queryFn for the actual fetching
  baseQuery: fetchBaseQuery({ baseUrl: "/" }),
  endpoints: (builder) => ({
    getLastUpdatedTime: builder.query<LastUpdatedResponse, void>({
      queryFn: async () => {
        try {
          const response = await axios.get<LastUpdatedResponse>("/api/reports/v1/system/last-updated");
          return { data: response.data };
        } catch (error: any) {
          // You might want to shape the error object here
          // based on your application's error handling needs
          return { error: { status: error.response?.status, data: error.response?.data || error.message } };
        }
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetLastUpdatedTimeQuery } = sendSessionsApi;
